import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Le due password non coincidono.");
    setError(null);
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password: form.password });
      setUser(false);
      toast.success(data.message);
      navigate("/accedi", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (!token)
    return (
      <div className="space-y-5 px-6 py-10" data-testid="reset-password-missing">
        <h1 className="font-serif text-3xl font-semibold text-[#0D2517]">Link non valido</h1>
        <p className="text-sm text-[#5b6b60]">Il link per reimpostare la password è incompleto. Richiedine uno nuovo.</p>
        <Link to="/password-dimenticata" className="btn-primary w-full" data-testid="reset-request-new">RICHIEDI UN NUOVO LINK</Link>
      </div>
    );

  return (
    <div className="px-6 py-10" data-testid="reset-password-page">
      <p className="eyebrow">Recupero accesso</p>
      <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Imposta una nuova password</h1>
      <p className="mt-2 text-sm text-[#5b6b60]">Dopo il salvataggio, le sessioni aperte su altri dispositivi verranno chiuse.</p>
      <form onSubmit={submit} className="mt-8 space-y-3" data-testid="reset-password-form">
        <input className="field" type="password" autoComplete="new-password" minLength={8} placeholder="Nuova password (min. 8 caratteri)" value={form.password} onChange={set("password")} required data-testid="reset-password-input" />
        <input className="field" type="password" autoComplete="new-password" minLength={8} placeholder="Ripeti la nuova password" value={form.confirm} onChange={set("confirm")} required data-testid="reset-password-confirm-input" />
        {error && <p className="text-sm text-[#B91C1C]" data-testid="reset-password-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit-button">{busy ? "Attendere…" : "SALVA LA NUOVA PASSWORD"}</button>
      </form>
      {error && <Link to="/password-dimenticata" className="mt-5 block text-center text-sm text-[#0D2517] underline underline-offset-4" data-testid="reset-request-new-link">Richiedi un nuovo link</Link>}
    </div>
  );
}
